export default __webpack_public_path__ + "static/media/hero-rafting_mirror.c96105a5.png";